export const rxsHtmlAttrValueMaybeInQuotes = String.raw`"[^"]*"|'[^']*'|[^='"<>\s&]*`;
export const rxsHtmlAttrKey = String.raw`[^=\s\0'"<>\/]+`;

export const rxsHtmlAttr = String.raw`\s+${rxsHtmlAttrKey}(?:\s*=\s*(?:${rxsHtmlAttrValueMaybeInQuotes}))?`;
export const rxsHtmlAttrCapture = String.raw`\s+(${rxsHtmlAttrKey})(?:\s*=\s*(${rxsHtmlAttrValueMaybeInQuotes}))?`;

export const rxsHtmlAttrs = `(?:${rxsHtmlAttr})*`;

export const rxHead = new RegExp(String.raw`<head${rxsHtmlAttrs}\s*\/?>`, 'i');

export const rxsComment = '(?=<!--)[^]*?-->';
